import { defineMessages } from 'react-intl'

const scope = `procurify.platform.integrations.features.disconnect-slack-integration`

export default defineMessages({
  confirmTitle: {
    id: `${scope}.confirmTitle`,
    defaultMessage: 'Disconnect Slack?',
  },
  confirmMessage: {
    id: `${scope}.confirmMessage`,
    defaultMessage:
      'Disconnecting will remove the Slack integration for your organization and clear existing user links. You can reconnect at any time.',
  },
  confirmButton: {
    id: `${scope}.confirmButton`,
    defaultMessage: 'Disconnect',
  },
  successTitle: {
    id: `${scope}.successTitle`,
    defaultMessage: 'Slack disconnected',
  },
  successMessage: {
    id: `${scope}.successMessage`,
    defaultMessage: 'The Slack integration has been disconnected.',
  },
  errorTitle: {
    id: `${scope}.errorTitle`,
    defaultMessage: 'Error',
  },
  errorMessage: {
    id: `${scope}.errorMessage`,
    defaultMessage: 'Failed to disconnect Slack. Please try again.',
  },
})
